// Colour media filter (custom). When the selected colour changes the set of
// media, replace the whole product gallery (slides + thumbnails) and zoom modal
// with the freshly rendered version, instead of Dawn's default updateMedia.
// See snippets/colour-media-ids.liquid.
(function () {
  if (window.colourMediaInit) return;
  window.colourMediaInit = true;

  function swap(productInfo, html) {
    var current = productInfo.querySelector('media-gallery');
    var incoming = html.querySelector('media-gallery');
    if (!current || !incoming) return false;
    if ((current.dataset.colourKey || '') === (incoming.dataset.colourKey || '')) return false;

    incoming.querySelectorAll('.scroll-trigger').forEach(function (el) {
      el.classList.add('scroll-trigger--cancel');
    });
    current.replaceWith(document.importNode(incoming, true));

    if (productInfo.hasAttribute('data-zoom-on-hover') && typeof enableZoomOnHover === 'function') {
      enableZoomOnHover(2);
    }

    var modal = productInfo.productModal && productInfo.productModal.querySelector('.product-media-modal__content');
    var newModal = html.querySelector('product-modal .product-media-modal__content');
    if (modal && newModal) modal.innerHTML = newModal.innerHTML;
    return true;
  }

  customElements.whenDefined('product-info').then(function () {
    var proto = customElements.get('product-info').prototype;
    if (proto.__colourMediaPatched) return;
    proto.__colourMediaPatched = true;
    var original = proto.updateMedia;
    proto.updateMedia = function (html, variantFeaturedMediaId) {
      try {
        if (swap(this, html)) return;
      } catch (e) {
        console.error(e);
      }
      return original.call(this, html, variantFeaturedMediaId);
    };
  });
})();
